import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import { waUrlBuilder } from "../../../pages/MyDataPage/components/utils/waSupportBuilder";

export const SupportButton = () => {

    const { t } = useTranslation();

    const callSupportExecute = () => {
        window.open(waUrlBuilder(), '_blank')
    }

    return (
        <Button
            variant="contained"
            sx={{
                textTransform: "none",
                background: "#22638D",
                font: "normal normal normal 14px/21px Segoe UI"
            }}
            onClick={() => callSupportExecute()}
        >
            {t("MyData.GetIn")}
        </Button>
    )
}